import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import { VoiceCreateFormComponent } from './VoiceCreateForm'
import { push } from 'react-router-redux'
import { createVoice } from '../Voices.actions'

export interface IVoiceCreateFormContainerProps {
  onCancel: () => undefined
  talentID?: string
}

const stateToProps = ({ form, auth }, { talentID }) => {
  const formName = 'voiceCreate'
  return {
    isLoggedIn: !!auth.token,
    form: formName,
    formData: get(form, `${formName}.values`, {}),
    noTalentSelection: !!talentID,
    initialValues: {
      step: 0,
      filter: {
        language: 'eng-au',
      },
      talentID,
      script: [],
    },
  }
}

export const dispatchToProps = {
  createVoice,
  push,
}

export const VoiceCreateForm = connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(VoiceCreateFormComponent as any)
)



// WEBPACK FOOTER //
// src/features/Voices/VoiceCreateForm/VoiceCreateForm.container.ts